var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#628AF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_890_554",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_890_554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0296 30C26.8738 30 24.7725 29.5207 22.7256 28.562C20.6781 27.604 18.8648 26.3373 17.2859 24.762C15.7063 23.1873 14.4362 21.379 13.4756 19.337C12.5143 17.2957 12.0337 15.2 12.0337 13.05C12.0337 12.75 12.134 12.5 12.3345 12.3C12.535 12.1 12.7857 12 13.0865 12H17.1475C17.3815 12 17.5904 12.075 17.7742 12.225C17.958 12.375 18.0667 12.5667 18.1001 12.8L18.7518 16.3C18.7853 16.5333 18.7813 16.7457 18.7398 16.937C18.6977 17.129 18.6014 17.3 18.451 17.45L16.0445 19.9C16.7464 21.1 17.6238 22.225 18.6766 23.275C19.7295 24.325 20.891 25.2333 22.1611 26L24.5174 23.65C24.6678 23.5 24.8644 23.3873 25.107 23.312C25.349 23.2373 25.587 23.2167 25.821 23.25L29.2803 23.95C29.5143 24 29.7065 24.1123 29.8569 24.287C30.0073 24.4623 30.0825 24.6667 30.0825 24.9V28.95C30.0825 29.25 29.9822 29.5 29.7817 29.7C29.5811 29.9 29.3304 30 29.0296 30Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.11c5398dd9c391051c4d4948b2e78f4e.svg";
export { ForwardRef as ReactComponent };